import React from 'react';
import MissionsLogic from '../components/missions/MissionsLogic';

function Missions() {
  return (
    <MissionsLogic />
  );
}

export default Missions;
